import React, { useState } from 'react';
import styles from './TextArea.module.css';

interface TextAreaProps {
  label: string;
  value: string;
  onChange: (value: string) => void;
  error?: string;
  placeholder?: string;
  disabled?: boolean;
  rows?: number;
  maxLength?: number;
  touched?: boolean;
}

export const TextArea: React.FC<TextAreaProps> = ({ label, value, onChange, error, placeholder, disabled = false, rows = 4, maxLength, touched }) => {
  const [isFocused, setIsFocused] = useState(false);

  const hasValue = value.length > 0;
  const isFloating = isFocused || hasValue;

  return (
    <div className={styles.container}>
      <div className={`${styles.textAreaWrapper} ${error ? styles.error : ''} ${isFocused ? styles.focused : ''} ${disabled ? styles.disabled : ''}`}>
        <label className={`${styles.label} ${isFloating ? styles.floating : ''}`}>{label}</label>
        <textarea
          value={value}
          onChange={e => onChange(e.target.value)}
          onFocus={() => setIsFocused(true)}
          onBlur={() => setIsFocused(false)}
          placeholder={isFloating ? placeholder : ''}
          disabled={disabled}
          rows={rows}
          maxLength={maxLength}
          className={styles.textArea}
        />
      </div>
      <div className={styles.footer}>
        {(touched === true || touched === undefined) && error && <div className={styles.errorMessage}>{error}</div>}
        {maxLength && (
          <div className={styles.charCount}>
            {value.length}/{maxLength}
          </div>
        )}
      </div>
    </div>
  );
};
